/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/unbound-method */

/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */

import { Component, OnInit } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { Title } from '@angular/platform-browser'
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router'
import { filter, map } from 'rxjs/operators'
import { TitleService } from '../../src/commons/services/ui/title.service'
import { IdleMessageComponent } from '../../src/commons/idle-message/idle-message.component'
import { MatDialog } from '@angular/material/dialog'
import { ApiService } from '../../src/commons/services/api/api.service'
import { ConfigSettingKey } from '../../src/commons/models/configSettings.model'
import { CacheService } from '../../src/commons/services/business/cache.service'
import { AuthWrapperService } from '../../src/security/models/services/auth'

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
  alert: any
  appLoaded = false

  constructor(
    private AuthWrapper: AuthWrapperService,
    public dialog: MatDialog,
    private readonly translate: TranslateService,
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly titleService: Title,
    private readonly titleAppService: TitleService,
    private readonly apiService: ApiService,
    private readonly cacheService: CacheService
  ) {
  }

  async ngOnInit(): Promise<void> {

    this.AuthWrapper.onInactive.subscribe((): void => {
      if (!this.alert)
        this.alert = this.dialog.open(IdleMessageComponent, { disableClose: true })
    })
    this.AuthWrapper.onActive.subscribe((): void => {
      if (this.alert) {
        this.alert.close()
        this.alert = null
      }
    })

    void this.validateSession()

    const appTitle = this.titleService.getTitle()
    this.router
      .events.pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => {
          let child = this.activatedRoute.firstChild
          while (child.firstChild) {
            child = child.firstChild
          }
          if (child.snapshot.data['title']) {
            return this.translateTitle(child.snapshot.data['title'])
          }
          return appTitle
        })
      ).subscribe((ttl: string) => {
        this.titleService.setTitle(ttl)
      })

    await this.setCommonConfigSettings()

    this.appLoaded = true
  }

  public async validateSession(): Promise<void> {
    const isAuthenticated = await this.AuthWrapper.isAuthenticated()
    if (isAuthenticated) {
      this.AuthWrapper.resetIdleTime()
      this.AuthWrapper.start()
    }
  }

  private translateTitle(titleKey: string): string {
    let translatedTitle = this.translate.instant(titleKey) as string

    //this case happens when you do an F5. JSON translated have not yet being loaded
    if (translatedTitle.indexOf('.') > 0) {
      translatedTitle = ''
    }

    return this.titleAppService.getTitle(translatedTitle)
  }

  async setCommonConfigSettings() {
    const commonConfigSettings = await this.apiService.getCommonConfigSettings()
    this.cacheService.setCommonConfigSettings(commonConfigSettings)

    const loginBackground = commonConfigSettings.find(x => x.configKey == ConfigSettingKey.LoginBackground)
    if (loginBackground) {
      document.documentElement.style.setProperty(
        '--cdn-image-login-background-desktop',
        `url(${loginBackground.configValue})`
      )
    }

    const watermark = commonConfigSettings.find(x => x.configKey == ConfigSettingKey.LogoWatermark)
    if (watermark) {
      document.documentElement.style.setProperty(
        '--cdn-image-watermark-transparent',
        `url(${watermark.configValue}`
      )
    }

    const logo = commonConfigSettings.find(x => x.configKey == ConfigSettingKey.Logo)
    if (logo) {
      document.documentElement.style.setProperty(
        '--sightline-logo',
        `url(${logo.configValue}`
      )
    }

    const logoWhite = commonConfigSettings.find(x => x.configKey == ConfigSettingKey.LogoWhite)
    if (logoWhite) {
      document.documentElement.style.setProperty(
        '--sightline-logo-white',
        `url(${logoWhite.configValue}`
      )
    }
  }
}
